import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import useFetch from "../../../hooks/useFetch";
import { useCallback, useEffect, useState } from "react";
import LastTriageCard from "./LastTriageCard";
import { ITriageEmergencyDepartments } from "../../../models/triage";
import TriageEmergencyDepartment from "../../../services/triageEmergencyDepartment.service";
import { useFormContext } from "react-hook-form";

const translationPath = "components.lastCalls.";

const LastTriage = () => {
  const { t } = useTranslation();
  const [triagesList, setTriagesList] = useState<ITriageEmergencyDepartments[]>(
    []
  );

  const { setValue } = useFormContext();

  const { sendRequest } = useFetch(TriageEmergencyDepartment.getTriages);

  const loadtriages = useCallback(async () => {
    const { data, success } = await sendRequest({ ReturnQuantity: "3" });
    if (success) {
      setTriagesList(
        data.triageEmergencyDepartments
          ? data.triageEmergencyDepartments.reverse()
          : []
      );
    }
  }, [sendRequest]);

  useEffect(() => {
    loadtriages();
  }, [loadtriages]);

  const onUseSymptom = (symptoms: string) => {
    setValue("anamnesis", symptoms);
  };

  return (
    <Stack mb={2}>
      <>
        <Typography variant="h6" mb={2}>
          {t(translationPath + "last_calls")}
        </Typography>
        <Stack display={"flex"} gap={2}>
          {triagesList.map((triage) => (
            <LastTriageCard
              onUseSymptom={onUseSymptom}
              triage={triage}
              key={triage.id}
            />
          ))}
        </Stack>
      </>
    </Stack>
  );
};

export default LastTriage;
